"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complex_utils_1 = require("complex-utils");
const utils_1 = require("@/config/utils");
const option_1 = __importDefault(require("@/style/option"));
const user_1 = __importDefault(require("@/data/user"));
const require_1 = __importStar(require("@/require"));
const vue_1 = require("vue");
let num = 0;
const preUrlConfig = {
    default: 'https://digital-test.wuzheng.com.cn/tsp/index.html#',
    dev: 'https://digital-dev.wuzheng.com.cn/tsp/index.html#',
    test: 'https://digital-test.wuzheng.com.cn/tsp/index.html#',
    prod: 'https://digital.wuzheng.com.cn/tsp/index.html#',
    getData() {
        return this[(0, complex_utils_1.getEnvMode)('data') || 'test'];
    }
};
function getTime() {
    num++;
    return Date.now().toString() + num.toString();
}
exports.default = (0, vue_1.defineComponent)({
    name: 'ExternalIframe',
    props: {
        target: {
            type: String,
            required: true
        },
        params: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        },
        preUrl: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            src: ''
        };
    },
    watch: {
        target: {
            immediate: true,
            handler() {
                this.changeSrc();
            }
        }
    },
    mounted() {
        window.addEventListener('message', this.onMessage);
        this.$nextTick(() => {
            this.changeSrc();
        });
    },
    beforeUnmount() {
        window.removeEventListener('message', this.onMessage);
        const iframe = this.$refs.iframe;
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.location.replace('');
            this.src = '';
            try {
                iframe.contentWindow.close(); // 避免iframe内存泄漏
                iframe.remove(); // 删除iframe
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
    },
    methods: {
        onMessage(event) {
            const message = event.data;
            if (message.type === 'ExternalLoaded') {
                this.initExternal();
            }
        },
        changeSrc() {
            var _a;
            const query = {
                time: getTime(),
                external: JSON.stringify({
                    style: {
                        color: {
                            primary: option_1.default.color.primary,
                            link: option_1.default.color.primary
                        }
                    }
                })
            };
            if (this.$refs.iframe) {
                if (!this.src) {
                    this.$refs.iframe.src = this.getSrc(query);
                }
                else {
                    (_a = this.$refs.iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.location.replace(this.getSrc(query));
                }
            }
        },
        getSrc(query) {
            this.src = (this.preUrl || preUrlConfig.getData()) + this.target;
            return (0, complex_utils_1.formatQueryUrl)(this.src, query);
        },
        loginResult() {
            return {
                userId: user_1.default.info.id,
                token: require_1.default.getToken('Authorization'),
                tokenTime: 0,
                tokenIssuer: require_1.default.getToken('X-Token-Issuer'),
                secret: require_1.refreshLogin.data.refreshToken,
                userInfo: {
                    id: user_1.default.info.id,
                    identity: user_1.default.info.id,
                    username: user_1.default.info.account,
                    realname: user_1.default.info.name
                }
            };
        },
        initExternal() {
            var _a;
            const from = (0, complex_utils_1.getRandomData)(16);
            const time = Date.now();
            const data = {
                time,
                user: this.loginResult(),
                params: this.params
            };
            const params = {
                type: 'initExternal',
                from: from,
                time: time,
                data: (0, utils_1.encrypt)(JSON.stringify(data), from)
            };
            (_a = this.$refs.iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(params, '*');
        }
    }
});
